import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { SourceHttpClient } from './source-http.client';
import { SourceActions } from './source.store';

@Injectable({ providedIn: 'root' })
export class SourceEffects {
  public effect = createEffectFactory(SourceActions, this.actions$);

  public fetchSources$ = this.effect(SourceActions.fetchCollection, () =>
    this.sourceHttpClient.fetch().pipe(map(sources => ({ data: sources }))),
  );

  constructor(private sourceHttpClient: SourceHttpClient, private actions$: Actions) {}
}
